/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../connect/v2/resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "corporate_card": {
        "nested": {
          "service": {
            "nested": {
              "CreateCreditCardWaitlistSignupRequest": {
                "fields": {}
              },
              "CreateCreditCardWaitlistSignupResponse": {
                "fields": {
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.CreateCreditCardWaitlistSignupRequest && !$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.CreateCreditCardWaitlistSignupResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE CreateCreditCardWaitlistSignupRequest @ squareup/corporate_card/service/create_credit_card_waitlist_signup.proto at 8:1
 */
export const CreateCreditCardWaitlistSignupRequest = $root.lookupType('squareup.corporate_card.service.CreateCreditCardWaitlistSignupRequest');
fixType(CreateCreditCardWaitlistSignupRequest);
Builder.createAndAttachToType(CreateCreditCardWaitlistSignupRequest);
/**
 * SOURCE CreateCreditCardWaitlistSignupResponse @ squareup/corporate_card/service/create_credit_card_waitlist_signup.proto at 11:1
 */
export const CreateCreditCardWaitlistSignupResponse = $root.lookupType('squareup.corporate_card.service.CreateCreditCardWaitlistSignupResponse');
fixType(CreateCreditCardWaitlistSignupResponse);
Builder.createAndAttachToType(CreateCreditCardWaitlistSignupResponse);